(ns frontend.view.settings.view
  (:require
   [reagent.core :as r]
   [potpuri.core :refer [index-by]]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.view.settings.db :as db]
   [frontend.subscription :as subscription]
   [frontend.routing :as routing]
   ;; Child Views
   [frontend.view.settings.new-tenant-invite :as new-tenant-view]
   [frontend.view.settings.sys-admin.tenants :as tenants-view]
   [frontend.view.settings.sys-admin.tenant :as tenant-view]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.logging :as logging]
   [frontend.page-components.default-page-layout :as default-page-layout]))

;;
;; This view is used as a template by each individual settings view
;; Individual views must call this view and give the "contents" as
;; children argument. See for example tenants.cljs for example.
;;

(defn view
  [_]
  (r/create-class
   {:component-did-mount
    (fn [_]
      (swap! db/state assoc-in [:new-tenant :tenant/default-currency] :eur) ; TODO why we have it hardcoded here?
      (when-not (:subscribing db/state)
        (swap! db/state assoc :subscribing true)
        (subscription/open ::settings
                           :settings
                           {}
                           (fn [{:keys [entities]}]
                             (->> entities
                                  (cu/only-entity :attachment/type :attachment.type/export)
                                  (index-by :db/id)
                                  (swap! db/state update :exports merge))
                             ;; @VATAJA check this out
                             ; TODO we can not use manage-entities here as is,
                             ; TODO we need to show disabled entities in settings view
                             ; TODO refactor manage-entities and uncomment it
                             ; (manage-entities session/reverse-lookup  db/state entities)
                             (->> entities
                                  (index-by :db/id)
                                  (swap! db/state update :entities merge))
                             (logging/performance "Processed Settings data")
                             :ok))))
    :component-will-unmount
    (fn [_]
      (subscription/close ::settings)
      (swap! db/state dissoc :subscribing))
    :reagent-render
    (fn [{:keys [_buttons-builder _view-key localized-view hide-back? hiccup toolbar-buttons-fn]}]
      [:<>
       [zap-toolbar/view db/state
        (if hide-back?
          (fn [_] localized-view)
          (partial zap-toolbar/back-button nil)) nil
        (or (when toolbar-buttons-fn
              (toolbar-buttons-fn db/state))
            [])]
       [:div
        {:class "pt-3 flex-1 overflow-auto"}
        #_[:div.settings-view__side-menu
           [side-menu/view view-key @db/role]]
        [:div
         (r/as-element hiccup)]]])}))

;; sys-admin only fields

(defmethod routing/render-view :settings-tenants
  [_]
  [default-page-layout/view
   {:class-name "zap-page settings"}
   [view
    {:view-key       :settings-tenants
     :hide-back?     false
     :localized-view (loc/tr :tenants)
     :hiccup         [tenants-view/view]}]])

(defmethod routing/render-view :settings-tenant
  [args]
  (let [tenant-id (-> args
                      :route-params
                      :id
                      js/parseInt)]
    [default-page-layout/view
     {:class-name "zap-page settings"}
     [view
      {:view-key       :settings-tenant
       :localized-view (loc/tr :tenant)
       :hiccup         [tenant-view/view tenant-id]
       :toolbar-buttons-fn (partial tenant-view/toolbar-buttons tenant-id)}]]))

(defmethod routing/render-view :settings-new-tenant
  [_]
  [default-page-layout/view
   {:class-name "zap-page settings"}
   [view
    {:view-key       :settings-new-tenant
     :localized-view (loc/tr :add-tenant)
     :hiccup         [new-tenant-view/view]}]])
